import { Controller } from '@hotwired/stimulus';
import { applyLeadFinderSearchFilters } from '../lead_finder/apply_search_filters';

export default class extends Controller {
    static targets = ["card"]
    static values = { filters: String }

    connect() {
    }

    select(event) {
        const selectedCard = event.currentTarget

        if (selectedCard.dataset.active === true) {
            return
        } else {
            this.activate(selectedCard)
        }
    }

    activate(card) {
        this.cardTargets.forEach(el => {
            el.dataset.active = "false"
            el.classList.remove("card-bc--active")
        })

        card.dataset.active = "true"
        card.classList.add("card-bc--active")
        this.applyFilters(card.dataset.searchCardsFiltersValue)
        // Optional: dispatch event for other controllers
        this.dispatch("change", {
            detail: { id: card.dataset.id }
        })
    }

    applyFilters(filters) {
        applyLeadFinderSearchFilters(typeof filters === 'string' ? JSON.parse(filters) : filters)
    }
}
